var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumTimer7 = function SvgNumTimer7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3",
    d: "M6.742 20.744q0-.912.312-1.608.336-.72 1.008-1.32l4.992-4.08v-2.16H2.037V7.52H17.83v6.096q0 .912-.312 1.632-.313.696-.985 1.32l-5.016 4.128V29H6.743z"
  })));
};
export default SvgNumTimer7;